import useAPI from '@/hooks/useAPI';
import PersonRepository from '@/repositories/PersonRepository';

const useLeadSourceChoices = (enabled = true) => {
  const personRepository = PersonRepository();

  return useAPI({
    queryKey: ['getLeadSources'],
    queryFn: async () => {
      return await personRepository.getLeadSources();
    },
    enabled
  });
};

export default useLeadSourceChoices;
